import { render, staticRenderFns } from "./VehicleFlags.vue?vue&type=template&id=272fefbc&scoped=true"
import script from "./VehicleFlags.vue?vue&type=script&lang=js"
export * from "./VehicleFlags.vue?vue&type=script&lang=js"
import style0 from "./VehicleFlags.vue?vue&type=style&index=0&id=272fefbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272fefbc",
  null
  
)

export default component.exports